import React, { type FC } from 'react'

import type { ActivityEmailEventType } from 'Types/beRecipientsApi'

import IconArrowPointer from 'Components/icons/IconArrowPointer'
import IconBanRegular from 'Components/icons/IconBanRegular'
import IconCircleCheck from 'Components/icons/IconCircleCheck'
import IconCircleExclamation from 'Components/icons/IconCircleExclamation'
import IconEnvelopeCircleCheck from 'Components/icons/IconEnvelopeCircleCheck'
import IconEye from 'Components/icons/IconEye'
import IconPaperPlane from 'Components/icons/IconPaperPlane'
import IconUserCheck from 'Components/icons/IconUserCheck'

interface ActivityStreamIconProps {
  activityType: ActivityEmailEventType
}

const ActivityStreamIcon: FC<ActivityStreamIconProps> = ({ activityType }) => {
  if (activityType === 'Bounces') {
    return <IconCircleExclamation width="18px" height="18px" fill="#ff9000" />
  }

  if (activityType === 'Clicks') {
    return (
      <IconArrowPointer
        width="19px"
        height="19px"
        fill="#ffc400"
        transform="scale(-1,1)"
      />
    )
  }

  if (activityType === 'Opens') {
    return <IconEye width="18px" height="18px" fill="#16a7cd" />
  }

  if (activityType === 'Sendings') {
    return <IconPaperPlane width="17px" height="17px" fill="#8acf61" />
  }

  if (activityType === 'Subscription') {
    return <IconCircleCheck width="18px" height="18px" fill="#39ba7c" />
  }

  if (activityType === 'SubscriptionConfirmation') {
    return <IconEnvelopeCircleCheck width="19px" height="19px" fill="#39ba7c" />
  }

  if (activityType === 'SubscriptionRequest') {
    return <IconUserCheck width="19px" height="19px" fill="#39ba7c" />
  }

  if (activityType === 'Unsubscription') {
    return <IconBanRegular width="17px" height="17px" fill="#fa4747" />
  }

  return null
}

export default ActivityStreamIcon
